<template>
  <Card>
    <CardHeader :title="$t('profile.personal_information')">
      <p class="card-header-icon" aria-label="more options" v-if="canPersonalDataEdit">
        <mat-icon icon="mdi-pencil" v-if="edit"></mat-icon>
        <a v-else @click="beginEdit()">{{ $t('editing.edit') }}</a>
      </p>
    </CardHeader>
    <card-content>
      <ValidationObserver ref="form">
        <form>
          <fieldset :disabled="!edit">
            <div class="field">
              <label class="label">{{ $t('profile.lastname') }}</label>
              <div class="control">
                <ValidationProvider
                  :name="$t('profile.lastname')"
                  rules="required|fio"
                  v-slot="{ errors, invalid }"
                >
                  <input
                    class="input"
                    type="text"
                    :placeholder="$t('profile.lastname')"
                    :value="form.lastname"                          
                    @input="changeLastname($event)"
                    @blur="trimx($event, 'lastname')"
                    :class="{ 'is-danger': invalid }"
                  />
                  <p class="help is-danger" v-if="invalid">{{ errors[0] }}</p>
                </ValidationProvider>
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $t('profile.firstname') }}</label>
              <div class="control">
                <ValidationProvider
                  :name="$t('profile.firstname')"
                  rules="required|fio"
                  v-slot="{ errors, invalid }"
                >
                  <input
                    class="input"
                    type="text"
                    :placeholder="$t('profile.firstname')"
                    :value="form.firstname"                          
                    @input="changeFirstname($event)"
                    @blur="trimx($event, 'firstname')"
                    :class="{ 'is-danger': invalid }"
                  />
                  <p class="help is-danger" v-if="invalid">{{ errors[0] }}</p>
                </ValidationProvider>
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $t('profile.patronymic') }}</label>
              <div class="control">
                <ValidationProvider
                  :name="$t('profile.patronymic')"
                  rules="fio"
                  v-slot="{ errors, invalid }"
                >
                  <input
                    class="input"
                    type="text"
                    :placeholder="$t('profile.patronymic')"
                    :value="form.middlename"                          
                    @input="changeMiddlename($event)"
                    @blur="trimx($event, 'middlename')"
                    :class="{ 'is-danger': invalid }"
                  />
                  <p class="help is-danger" v-if="invalid">{{ errors[0] }}</p>
                </ValidationProvider>
              </div>
            </div>
            <div class="field">
              <ValidationProvider
                ref="emailValidationProvider"
                :name="$t('profile.email_label')"
                rules="required"
                v-slot="{ errors, invalid }"
              >
                <label class="label">{{ $t('profile.email_label') }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="email"
                    :placeholder="$t('profile.email')"
                    v-model="form.email"
                    :class="{ 'is-danger': invalid }"
                  />
                </div>
                <p class="help is-danger" v-if="invalid">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>
            <div class="field">
              <ValidationProvider 
                :name="$t('profile.mobile_phone_label')" 
              >
                  <label class="label mb-0">{{ $t('profile.mobile_phone_label') }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    :placeholder="$t('profile.mobile_phone')"
                    :value="form.phone"
                    @input="onPhoneInput"
                    :class="{ 'is-danger': !phoneValid }"
                  />
                </div>
                <p class="help is-danger" v-if="!phoneValid">{{ $t('profile.phoneValidationError') }}</p>
              </ValidationProvider>
            </div>
          </fieldset>
          <div v-if="canPersonalDataEdit && !edit && !phoneVerificationActive && currentData.phone" class="level level-left is-narrow" style="margin-top: 0.25rem;">
            <phone-verification-status :isVerified="currentData.phoneVerified"></phone-verification-status>
            <button v-if="!currentData.phoneVerified" @click="onPhoneVerifyClick" class="button ml-3" type="button" style="margin-left: 1rem;">{{$t('profile.confirm')}}</button>
            <button @click="onRemovePhoneClick()" v-if="currentData.phoneVerified" class="button ml-3" type="button" style="margin-left: 1rem;">{{
                $t('profile.removePhone')
              }}
            </button>
          </div>
        </form>
      </ValidationObserver>
    </card-content>
    <card-footer v-if="edit">
      <a class="card-footer-item" @click="save()">{{ $t('editing.save') }}</a>
      <a class="card-footer-item" @click="endEdit()">{{ $t('editing.cancel') }}</a>
    </card-footer>
    <div class="box" v-if="canPersonalDataEdit && phoneVerificationActive">
      <sms-details @close="onPhoneVerifyClose" :img="smsImage" :sms="sms"></sms-details>
    </div>

  </Card>
</template>

<script>
import { mapGetters } from "vuex";
import profile from "@/services/profile";
import PhoneVerificationStatus from "@/components/PhoneVerificationStatus";
import SmsDetails from "../AuthFactors/SmsDetails";
export default {
  name: "PersonalData",
  components: {
    SmsDetails, 
    PhoneVerificationStatus    
  },
  data() {
    return {
      smsImage: require("@/assets/sms.png"),
      edit: false,
      phoneVerificationActive: false,
      currentData: {
        lastname: "",
        firstname: "",
        middlename: "",
        email: "",
        phone: "",
        phoneVerified: false,
      },
      enterPhone: false,
      form: {
        lastname: "",
        firstname: "",
        middlename: "",
        email: "",
        phone: "",
        phoneVerified: false,
      },
      phoneValid: true,
    };
  },
  methods: {
    fetch() {
      profile.fetch().then(
        resp => {
          Object.assign(this.currentData, resp.data);
          Object.assign(this.form, this.currentData);
        },
        err => {
          console.log(err);
        }
      );
    },
    onPhoneVerifyClick() {
      this.enterPhone = true;
      if (!this.currentData.phone) {
        return;
      }
      this.phoneVerificationActive = true;
    },
    onPhoneVerifyClose() {
      this.fetch();
      this.phoneVerificationActive = false;
    },
    onRemovePhoneClick() {
      profile.removePhone().then(() => {
        this.currentData.phone = "";
        this.fetch();
      }).catch(() => {
      })
    },
    onPhoneInput(event) {
      this.phoneValid = true 
      const allowed = '0123456789 -+';
      this.form.phone = event.target.value.trimLeft().split('').reduce((acc, val) => {
        if (allowed.indexOf(val) >= 0) {
          acc.push(val);
        }
        return acc;
      }, []).join('').replace(/\s+/g, ' ');
    },
    beginEdit() {
      this.edit = true;
    },
    endEdit() {
      this.edit = false;
      Object.assign(this.form, this.currentData);
    },
    save() {
      this.phoneValid = true

      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }
        const data = {
          username: this.$store.state.user.name,
          lastname: this.form.lastname,
          firstname: this.form.firstname,
          middlename: this.form.middlename,
          email: this.form.email,
          phone: this.form.phone
        };
        profile.save(data).then(
          () => {
            Object.assign(this.currentData, this.form);
            this.edit = false;
            this.fetch();
          },
          err => {
            if(typeof err.response.data == 'string'){
              const code = err.response.data
              if(code == "PhoneHasInvalidFormat"){
                this.phoneValid = false
              }
            }else{
              const code = err.response.data.error.code;
              const errMessage = err.response.data.error.message;
              if (code == "InvalidEmail" && errMessage) {
                this.$refs.emailValidationProvider.setErrors([errMessage]);
              }
            }

            
          }
        ).catch(err => {
          console.log(err);
        });
      });
    },
    changeLastname(event) {
      if (/^(?!-)(?!\s)(?!.*--)(?!.* {2,})(?!.*- )(?!.* -)(?!.*'')(?!.*'-)(?!.*-')(?!.* ')(?!.*' )[a-zA-Zа-яА-ЯёЁ'-\s]*$/i.test(event.target.value)) {
        this.form.lastname = event.target.value;
      } else {
        event.target.value = this.form.lastname;
      }
    },
    changeFirstname(event) {
      if (/^(?!-)(?!\s)(?!.*--)(?!.* {2,})(?!.*- )(?!.* -)(?!.*'')(?!.*'-)(?!.*-')(?!.* ')(?!.*' )[a-zA-Zа-яА-ЯёЁ'-\s]*$/i.test(event.target.value)) {
        this.form.firstname = event.target.value;
      } else {
        event.target.value = this.form.firstname;
      }
    },
    changeMiddlename(event) {
      if (/^(?!-)(?!\s)(?!.*--)(?!.* {2,})(?!.*- )(?!.* -)(?!.*'')(?!.*'-)(?!.*-')(?!.* ')(?!.*' )[a-zA-Zа-яА-ЯёЁ'-\s]*$/i.test(event.target.value)) {
        this.form.middlename = event.target.value;
      } else {
        event.target.value = this.form.middlename;
      }
    },
    trimx(event, name) {
      var value = event.target.value.trim().replace(/-$/, '').replace(/'$/, '');
      this.$set(this.form, name, value);
    }
  },
  computed: {
    ...mapGetters(["canPersonalDataView", "canPersonalDataEdit"]),
    sms() {
      return {
        phone: this.currentData.phone,
        verified: this.currentData.phoneVerified
      };
    },
  },
  mounted() {
    this.fetch();
  }
};
</script>
